// Client-safe helpers for the preview-safe trauma activation link (/activate).
import { TRAUMA_COURSE_IDS } from "./ids";

export const ACTIVATION_FALLBACK = "/portal/courses";

/** Whitelist: exactly /portal/courses or /courses/trauma/<known id>/play. */
export function safeActivationDestination(to: unknown): string {
  if (typeof to !== "string") return ACTIVATION_FALLBACK;
  if (to === ACTIVATION_FALLBACK) return to;
  const m = /^\/courses\/trauma\/([a-z-]+)\/play$/.exec(to);
  if (m && (TRAUMA_COURSE_IDS as readonly string[]).includes(m[1])) return to;
  return ACTIVATION_FALLBACK;
}

/** Destination for a trauma product slug, or null when the slug is not trauma-*. */
export function traumaActivationDestination(slug: string): string | null {
  if (!slug.startsWith("trauma-")) return null;
  if (slug === "trauma-bundle") return ACTIVATION_FALLBACK;
  return safeActivationDestination(`/courses/trauma/${slug.slice("trauma-".length)}/play`);
}

/** Token and destination live in the fragment: never sent to servers or logs. */
export function activationLink(origin: string, hashedToken: string, to: string): string {
  return `${origin}/activate#t=${encodeURIComponent(hashedToken)}&to=${encodeURIComponent(to)}`;
}
